import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import { site } from "@/data/site";
import { getProject } from "@/lib/projects";
import { buildEnquiry, waUrl } from "@/lib/enquiry";

const WhatsAppIcon = ({ size = 22 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.359.101 11.945c0 2.096.549 4.142 1.595 5.945L0 24l6.335-1.652a11.96 11.96 0 005.71 1.454h.006c6.585 0 11.946-5.359 11.949-11.945a11.9 11.9 0 00-3.48-8.4z" />
    </svg>
);

export const FloatingButtons = () => {
    const { pathname } = useLocation();
    const match = pathname.match(/^\/projects\/(.+)$/);
    const project = match ? getProject(match[1]) : null;
    const waHref = waUrl(buildEnquiry(project?.name, "general"));

    return (
        <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
            <motion.a
                href={`tel:${site.contact.phone}`}
                data-testid="floating-call-button"
                aria-label="Call Swastik Realty"
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 2.4, duration: 0.5 }}
                whileHover={{ scale: 1.07 }}
                whileTap={{ scale: 0.94 }}
                className="flex items-center justify-center rounded-full border border-line bg-white text-charcoal shadow-[0_10px_30px_rgba(43,43,43,0.12)] transition-colors duration-300 hover:border-orange hover:text-orange"
                style={{ height: 52, width: 52 }}
            >
                <Phone size={20} />
            </motion.a>
            <motion.a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="floating-whatsapp-button"
                aria-label="Chat on WhatsApp"
                initial={{ opacity: 0, scale: 0.6 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 2.5, duration: 0.5 }}
                whileHover={{ scale: 1.07 }}
                whileTap={{ scale: 0.94 }}
                className="flex items-center justify-center rounded-full bg-orange text-white shadow-[0_12px_34px_rgba(217,134,44,0.4)] transition-colors duration-300 hover:bg-orange-dark"
                style={{ height: 56, width: 56 }}
            >
                <WhatsAppIcon size={26} />
            </motion.a>
        </div>
    );
};
